angular.module('bizmetryApp')
  .service('AgentConfigService', ['$mdDialog', function ($mdDialog) {
    this.openDialog = function(agent, saveAgentConfig) {
      const dialogEl = document.querySelector('.profile-details-dialog');
      if (dialogEl) dialogEl.classList.add('md-dialog-is-blurred');

      return $mdDialog.show({
        controller: 'AgentConfigDialogController',
        templateUrl: 'profile/tabs/agents/configuration/agent-config-dialog.html',
        parent: angular.element(document.body),
        multiple: true,
        clickOutsideToClose: true,
        escapeToClose: false,
        locals: {
          agent: agent,
          saveAgentConfig: saveAgentConfig
        }
      }).finally(function () {
        if (dialogEl) dialogEl.classList.remove('md-dialog-is-blurred');
      });
    };

    
  }]);
